import React, { useEffect, useState } from "react";
import Tippy from "@tippyjs/react";
/**
 * Toggle with slider that can set state in the parent, or run another onChange function when toggled.
 * 
 * @param {Boolean} checked 
 * @param {string} id 
 * @param {string} labelText 
 * @param {Function} setParentState 
 * @param {Function} onChange - allows parent component to handle the change in state or call the api directly
 * 
 * @returns {JSX.Element}
 * 
 * @category Components - UI
 */
export const Toggle = ({checked, id, labelText, locked, lockMessage = null, setParentState, onChange}) => {
    const [isChecked, setIsChecked] = useState(checked);
    useEffect(() => {
        setIsChecked(checked);
    }, [checked]);

    const handleCheckClick = async() => {
        const value = !isChecked;

        if(setParentState){
            setParentState(value);
            setIsChecked(value);
        }
        if(onChange){
            let result = await onChange(value);
            if(result){
                setIsChecked(value); //only changes value once response is received
            }
        }
    }
    
    return (
        <>
            <style>
                {`
                    .toggle-switch {
                        position: relative;
                        display: inline-block;
                        width: 40px;
                        height: 20px;
                    }
    
                    .toggle-switch input {
                        opacity: 0;
                        width: 0;
                        height: 0;
                    }
    
                    .toggle-slider {
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        background-color: #ccc;
                        
                        transition: .4s;
                        border-radius: 34px;
                    }
    
                    .toggle-slider:before {
                        position: absolute;
                        content: "";
                        height: 16px;
                        width: 16px;
                        left: 2px;
                        bottom: 2px;
                        background-color: white;
                        transition: .4s;
                        border-radius: 50%;
                    }
    
                    input:checked + .toggle-slider {
                        background-color: rgb(88 28 135);
                    }
    
                    input:checked + .toggle-slider:before {
                        transform: translateX(20px);
                    }
                `}
            </style>
            <label
                className="text-sm mr-5"
                htmlFor={id}
            >
                {labelText}
            </label>
            <label className="toggle-switch">
                <input
                    id={id}
                    name={id}
                    type="checkbox"
                    checked={isChecked}
                    onChange={handleCheckClick}
                    disabled={locked}
                />

                {locked && lockMessage ? (
                    <Tippy content={lockMessage} placement="top">
                        <span className="toggle-slider cursor-help"></span>
                    </Tippy>
                ) : (
                    <span className="toggle-slider"></span>
                )}
            </label>
        </>
    )
}